<div>
    <p>
        <strong>What is a cookie?</strong>
    </p>
    <p>
        A cookie is a small text file placed on your device by the websites that you visit. Cookies are then sent back
        to the website on each subsequent visit, or to another webpage that recognizes that cookie. Cookies are used in
        order to make the website work, or to work more efficiently, as well as to provide information to the owners of
        the website. Such information may be used to provide a more personalized and responsive service. Cookies may be
        either first party cookies set directly by us to your device, or third-party cookies set by a third-party
        provider on our behalf. Whenever you use this system, information may be collected through the use of cookies
        and other similar technologies (e.g., web beacons, tags, scripts, local storage).
    </p>
    <p>
        This Cookie Notice is part of our <a href="https://submissionplatform.deloitte.com/privacy">Privacy</a>
        Notice. For more information about us, and how
        process personal information, please see our <a
            href="https://submissionplatform.deloitte.com/privacy">Privacy</a> Notice.
    </p>
    <p>
        <strong>Cookies we may use and why</strong>
    </p>
    <p>
        This system uses cookies and web beacons that are classified into the following categories:
    </p>
    <div>
        <ul>
            <li>
                <span>
                    “Strictly Necessary” which are necessary for the system to function and cannot be switched off in
                    our systems. They are set in response to actions made by you which amount to a request for services,
                    such as authenticating into the system or managing your session with the requested service.
                </span>
            </li>
            <li>
                <span>
                    “Analytics and Performance” which are necessary for our non-public and internal systems to measure
                    audience and usage statistics, as well as content consumption. These enable us to obtain relevant
                    usage information to produce internal analytics so we can monitor and improve the performance of our
                    systems. These cannot be switched off in our non-public or internal systems.
                </span>
            </li>
        </ul>
    </div>
    <p>To view a list of the cookies that are used by the system, click on the View Cookies in the sidebar of the
        application
    </p>
    <p>
        <strong>How long will cookies remain on my device? </strong>
    </p>
    <p>The length of time cookies will stay on your device will depend on whether it is a “persistent” or “session”
        cookie. A persistent cookie will be stored by a web browser and will remain valid until its set expiration date,
        unless deleted by you before the expiration date. A session cookie, on the other hand, will expire at the end of
        your web session, when the web browser is closed.
    </p>
    <p><strong>Controller of the Cookies: </strong>
    </p>
    <p>
        Deloitte Global Services Limited with registered office at Hill House, 1 Little New Street, London, EC4A 3TR
        decided to use the cookies specified on the website.
    </p>
</div>